import { NgModule } from '@angular/core';
import { SharedModule } from 'lib-trend-core';
import { InfoFormComponent } from './info-form/info-form.component';
import { InfoRoutingModule } from './info-routing.module';
import { InfoComponent } from './info.component';

@NgModule({
  imports: [
    SharedModule,
    InfoRoutingModule,
  ],
  declarations: [
    InfoComponent,
    InfoFormComponent,
  ],
  exports: [
    InfoComponent,
    InfoFormComponent,
  ],
  providers: [],
  schemas: [],
})
export class InfoModule { }
